module.exports = __webpack_public_path__ + "c07d575af4e4ba874fd689903a9518f8.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/story_text.svg
 ** module id = 277
 ** module chunks = 0
 **/